/*
 * topic level layout for the reviewer module
 */

define(["marionette", "modules/reviewer/template/reviewerTemplate.html"], function (
  Marionette,
  ReviewerTemplate,
) {
  var ReviewerView = {};

  ReviewerView.reviewerLayout = Marionette.Layout.extend({
    template: ReviewerTemplate,
    regions: {
      list: "#reviewList",
      area: "#reviewArea",
      listToggle: "#reviewListToggle",
      reviewTypeToggle: "#reviewTypeToggle",
    },
    triggers: {
      "click #addTask": "add:task",
    },
  });

  return ReviewerView;
});
